import moment from 'moment';
import { parseDateApiFormat, parseDateInputFormat } from '../../utils/parseDateFormats';

export const getPerDiemReport = (state) => {
  return state.perDiemReport;
};

export const getEndDate = (state) => {
  const { endDate } = getPerDiemReport(state);
  return endDate;
};

export const getEndDateApiFormat = (state) => {
  const endDate = getEndDate(state);
  return (!endDate) ? endDate : parseDateApiFormat(endDate);
};

export const getEndDateInputFormat = (state) => {
  const endDate = getEndDate(state);
  return (!endDate) ? endDate : parseDateInputFormat(endDate);
};

export const getDistrictId = (state) => {
  const { district } = getPerDiemReport(state);
  return (district) ? district.id : null;
};

export const getDistrict = (state) => {
  const { district } = getPerDiemReport(state);
  return district;
};

export const getDepartmentId = (state) => {
  const { department } = getPerDiemReport(state);
  return (department) ? department.id : null;
};

export const getDepartment = (state) => {
  const { department } = getPerDiemReport(state);
  return department;
};

export const getStartDateApiFormat = (state) => {
  const endDate = getEndDate(state);
  if (!endDate) {
    return endDate;
  }
  const momentEndDate = parseDateApiFormat(endDate);
  return parseDateApiFormat(moment(momentEndDate).subtract(7, 'day'));
};

export const getEndDateCalendarInput = (state) => {
  const endDate = getEndDate(state);
  return new Date(endDate);
};
